/**
 * --------------------------------------------------------------------------
 *   Theme → Components
 *   @see https://v2.grommet.io/components
 * --------------------------------------------------------------------------
 */

import accordion from './controls/Accordion';
import anchor from './controls/Anchor';
import avatar from './visualizations/Avatar';
import box from './layout/Box';
import button from './controls/Button';
import calendar from './visualizations/Calendar';
import card from './layout/Card';
import cards from './visualizations/Cards';
import carousel from './media/Carousel';
import chart from './visualizations/Chart';
import checkBox from './input/CheckBox';
import checkBoxGroup from './input/CheckBoxGroup';
import clock from './visualizations/Clock';
import data from './data/Data';
import dataChart from './visualizations/DataChart';
import dataClearFilters from './data/DataClearFilters';
import dataFilter from './data/DataFilter';
import dataFilters from './data/DataFilters';
import dataSearch from './data/DataSearch';
import dataSort from './data/DataSort';
import dataSummary from './data/DataSummary';
import dataTable from './visualizations/DataTable';
import dataTableColumns from './data/DataTableColumns';
import dataTableGroupBy from './data/DataTableGroupBy';
import dataView from './data/DataView';
import dateInput from './input/DateInput';
import diagram from './visualizations/Diagram';
import distribution from './visualizations/Distribution';
import drop from './controls/Drop';
import dropButton from './controls/DropButton';
import fileInput from './input/FileInput';
import footer from './layout/Footer';
import form from './input/Form';
import formField from './input/FormField';
import grid from './layout/Grid';
import header from './layout/Header';
import heading from './type/Heading';
import icon from './visualizations/Icon';
import image from './media/Image';
import layer from './layout/Layer';
import list from './visualizations/List';
import main from './layout/Main';
import markdown from './type/Markdown';
import maskedInput from './input/MaskedInput';
import menu from './controls/Menu';
import meter from './visualizations/Meter';
import nameValueList from './visualizations/NameValueList';
import nav from './controls/Nav';
import notification from './visualizations/Notification';
import page from './layout/Page';
import pageHeader from './layout/PageHeader';
import pagination from './visualizations/Pagination';
import paragraph from './type/Paragraph';
import radioButton from './input/RadioButton';
import radioButtonGroup from './input/RadioButtonGroup';
import rangeInput from './input/RangeInput';
import rangeSelector from './input/RangeSelector';
import select from './input/Select';
import selectMultiple from './input/SelectMultiple';
import sidebar from './layout/Sidebar';
import skeleton from './visualizations/Skeleton';
import spinner from './visualizations/Spinner';
import stack from './layout/Stack';
import starRating from './input/StarRating';
import table from './visualizations/Table';
import tabs from './controls/Tabs';
import tag from './type/Tag';
import text from './type/Text';
import textArea from './input/TextArea';
import textInput from './input/TextInput';
import thumbsRating from './input/ThumbsRating';
import tip from './controls/Tip';
import toggleGroup from './controls/ToggleGroup';
import toolbar from './data/Toolbar';
import video from './media/Video';
import worldMap from './visualizations/WorldMap';

const componentsControls = {
  accordion,
  anchor,
  button,
  drop,
  dropButton,
  menu,
  nav,
  tabs,
  tip,
  toggleGroup,
};

const componentsData = {
  data,
  dataClearFilters,
  dataFilter,
  dataFilters,
  dataSearch,
  dataSort,
  dataSummary,
  dataTableColumns,
  dataTableGroupBy,
  dataView,
  toolbar,
};

const componentsInput = {
  checkBox,
  checkBoxGroup,
  dateInput,
  fileInput,
  form,
  formField,
  maskedInput,
  radioButton,
  radioButtonGroup,
  rangeInput,
  rangeSelector,
  select,
  selectMultiple,
  starRating,
  textArea,
  textInput,
  thumbsRating,
};

const componentsLayout = {
  box,
  card,
  footer,
  grid,
  header,
  layer,
  main,
  page,
  pageHeader,
  sidebar,
  stack,
};

const componentsMedia = {
  carousel,
  image,
  video,
};

const componentsType = {
  heading,
  markdown,
  paragraph,
  tag,
  text,
};

const componentsVisualizations = {
  avatar,
  calendar,
  cards,
  chart,
  clock,
  dataChart,
  dataTable,
  diagram,
  distribution,
  icon,
  list,
  meter,
  nameValueList,
  notification,
  pagination,
  skeleton,
  spinner,
  table,
  worldMap,
};

export default {
  ...componentsControls,
  ...componentsData,
  ...componentsInput,
  ...componentsLayout,
  ...componentsMedia,
  ...componentsType,
  ...componentsVisualizations,
};
